import * as API from 'common/constant/routes'
import { getJson } from 'helper/http'

export const getCarouselInformation = () => getJson(API.GET_CAROUSEL_INFORMATION)
